export const AD_IMAGE_EXTENSIONS = [
  'jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'avif', 'heic', 'heif', 'tif', 'tiff', 'ico',
]

export const AD_VIDEO_EXTENSIONS = [
  'mp4', 'm4v', 'mov', 'webm', 'avi', 'mkv', 'mpeg', 'mpg', '3gp', 'ogv', 'wmv',
]

export const AD_IMAGE_FORMAT_HINT = 'JPG, PNG, GIF, WebP, SVG, BMP, AVIF, HEIC, or TIFF. Max 20MB.'

export const AD_VIDEO_FORMAT_HINT = 'MP4, MOV, WebM, M4V, AVI, MKV, MPEG, 3GP, OGV, or WMV. Max 20MB.'

export const AD_IMAGE_FORMAT_ERROR = 'Please upload a valid image (JPG, PNG, GIF, WebP, SVG, BMP, AVIF, HEIC, or TIFF).'

export const AD_VIDEO_FORMAT_ERROR = 'Please upload a valid video (MP4, MOV, WebM, M4V, AVI, MKV, MPEG, 3GP, OGV, or WMV).'

const GENERIC_FILE_TYPES = new Set(['', 'application/octet-stream', 'binary/octet-stream', 'text/plain'])

function fileExtension(file) {
  return String(file?.name || '').split('.').pop().toLowerCase()
}

function fileMime(file) {
  return String(file?.type || '').toLowerCase()
}

export function isAllowedAdImageFile(file) {
  if (!file) return false
  const ext = fileExtension(file)
  const mime = fileMime(file)
  if (!AD_IMAGE_EXTENSIONS.includes(ext)) {
    return ext === '' && mime.startsWith('image/')
  }
  if (GENERIC_FILE_TYPES.has(mime)) return true
  if (ext === 'svg') {
    return mime.startsWith('image/') || mime.includes('xml') || mime.startsWith('text/')
  }
  return mime.startsWith('image/')
}

export function isAllowedAdVideoFile(file) {
  if (!file) return false
  const ext = fileExtension(file)
  const mime = fileMime(file)
  if (!AD_VIDEO_EXTENSIONS.includes(ext)) {
    return ext === '' && mime.startsWith('video/')
  }
  if (GENERIC_FILE_TYPES.has(mime)) return true
  return mime.startsWith('video/') || mime === 'application/ogg'
}

export function isAdVideoFile(file) {
  const ext = fileExtension(file)
  const mime = fileMime(file)
  return AD_VIDEO_EXTENSIONS.includes(ext) || mime.startsWith('video/')
}

export function isVideoMediaUrl(url) {
  const path = String(url || '').split('?')[0].split('#')[0].toLowerCase()
  return AD_VIDEO_EXTENSIONS.some(ext => path.endsWith(`.${ext}`))
}

export function fileMatchesAdType(file, adType) {
  return String(adType || '').toLowerCase() === 'video'
    ? isAllowedAdVideoFile(file)
    : isAllowedAdImageFile(file)
}

export function adMediaAccept(adType) {
  if (String(adType || '').toLowerCase() === 'video') {
    return [...AD_VIDEO_EXTENSIONS.map(ext => `.${ext}`), 'video/*'].join(',')
  }
  return [...AD_IMAGE_EXTENSIONS.map(ext => `.${ext}`), 'image/*', 'image/svg+xml'].join(',')
}

export function adMediaFormatError(adType) {
  return String(adType || '').toLowerCase() === 'video' ? AD_VIDEO_FORMAT_ERROR : AD_IMAGE_FORMAT_ERROR
}

export function adMediaFormatHint(adType) {
  return String(adType || '').toLowerCase() === 'video' ? AD_VIDEO_FORMAT_HINT : AD_IMAGE_FORMAT_HINT
}
